import React from 'react'

import {AddUser_Manager} from "../../model/manager"
import UserToAdd from "../../model/add-user"
import CheckBox, {CheckboxType} from "../../../../gd-components/checkbox/checkbox"
import UserIcon from "../../../../gd-components/icons/user/user"
import ModalAddUser_SectionMoreButton from "./section-more/more-button"
import ModalAddUser_MeetingRoleCell from "./meeting-role-cell"

type Props = {
    className?          : string
    showMeetingRole?    : boolean

    manager             : AddUser_Manager
}

export default function ModalAddUser_AddToTaskOrChat(props: Props) {

    const isMultiselectEnabled = props.manager.multiselect

    const toggleUser = (userToAdd:UserToAdd) => {
        if (!isMultiselectEnabled) {
            props.manager.unselectAll()
        }

        userToAdd.toggleIsSelected()
        props.manager.reRender()
    }

    return (
        <>
            <div className="ui5-tabled-dashed w-100p">
                <div className="table-header">
                    <div className="cell flex-1 flex-row-left-center">
                        <div className="ifl-ac show-hidden-on-hover">
                            <div className="ui5-title-small">
                                Project Users
                            </div>

                            <ModalAddUser_SectionMoreButton
                                className   = "m-l-5"
                                manager     = {props.manager}
                                usersToAdd  = {props.manager.projectUsersToAdd}
                            />
                        </div>
                    </div>

                    {props.showMeetingRole &&
                        <div className="cell w-160">
                            {props.manager.projectUsersToAdd.atLeastOneChecked &&
                                <div className="ui5-grid-header">
                                    Meeting Role
                                </div>
                            }
                        </div>
                    }
                </div>

                {_.isEmpty(props.manager.projectUsersToAdd.available) &&
                    <div className="table-row">
                        <div className="flex-row-center-center ui5-txt-not-important">
                            No users found
                        </div>
                    </div>}

                {_.map(props.manager.projectUsersToAdd.available, (userToAdd:UserToAdd, key:number)=>{
                    const rowClasses = Classes("table-row", {
                        'ui5-bg-gray'   : userToAdd.isSelected,
                        'p-l-5'         : !isMultiselectEnabled
                    })

                    return (
                        <div key={key} className={rowClasses} onClick={toggleUser.bind(null, userToAdd)}>
                            <div className="cell flex-1 flex-row-left-center">
                                {isMultiselectEnabled &&
                                    <CheckBox className = "m-r-10 m-l-5"
                                              type      = {CheckboxType.FILLED}
                                              isChecked = {userToAdd.isSelected} />}
                                <UserIcon className = "m-r-8"
                                          size      = "22"
                                          userId    = {userToAdd.id}/>
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>

                            {props.showMeetingRole &&
                                <ModalAddUser_MeetingRoleCell
                                    manager     = {props.manager}
                                    userToAdd   = {userToAdd}
                                />
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
}
